import { render } from "./XmlAttributeValue.vue?vue&type=template&id=36c46cbc&scoped=true"
import script from "./XmlAttributeValue.vue?vue&type=script&lang=js"
export * from "./XmlAttributeValue.vue?vue&type=script&lang=js"

import "./XmlAttributeValue.vue?vue&type=style&index=0&id=36c46cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c46cbc"]])

export default __exports__